import { Component } from '@angular/core';
import { AuthService } from '../../../../services/AuthService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss','../Styles/shared.scss']
})
export class PasswordResetComponent {
  email: string = '';
  code: string = '';
  newPassword: string = '';
  isResetConfirmed: boolean = false;
  error: string = '';

  constructor(private authService: AuthService, private router: Router) {}

  async sendResetCode() {
    try {
     await this.authService.handleResetPassword(this.email);
      this.isResetConfirmed = true;
      this.error = ''
    } catch (error:any) {
      console.error('Error sending reset code:', error);
      this.error = "There is no account associated with this email address"
    }
  }

  async confirmResetPassword() {
    try {
      await this.authService.handleConfirmResetPassword(
        this.email, 
        this.code, 
        this.newPassword
      );
      this.router.navigate(['/login']);

    } catch (error:any) {
      console.error('Error resetting password:', error);
      this.error = error.message
    }
  }

}
